import React from 'react';

import classNames from 'classnames';
import Image from 'next/image';

import styles from './product-configuration-visid.module.scss';

interface ImageRenderProps {
  src: string;
  title: string;
  id: string;
  loadingImage: boolean;
  setLoadingImage: (loading: boolean) => void;
  sku: string;
  disabled?: boolean;
  nonSelectedPrinter?: boolean;
}

const ImageRenderer: React.FC<ImageRenderProps> = (props: ImageRenderProps) => {
  const {
    src,
    title,
    id,
    sku,
    loadingImage,
    setLoadingImage,
    nonSelectedPrinter,
    disabled,
  } = props;

  const imageStyle =
    styles[`image${nonSelectedPrinter ? '-non-selected' : ''}`];

  const handleImageStyle = classNames(
    loadingImage ? styles['loading-image'] : imageStyle,
    disabled && styles['image-opacity']
  );

  return (
    <div className={styles['image-container']}>
      <Image
        src={src}
        alt={title}
        sizes="100"
        unoptimized
        loading="lazy"
        quality={70}
        width={0}
        height={0}
        id={id}
        data-testid={`${sku}-image`}
        className={handleImageStyle}
        onLoad={() => setLoadingImage(false)}
      />
    </div>
  );
};

export default ImageRenderer;
